import { Link } from "react-router-dom";

export const Support = () => {
  return (
    <section className="af-section" data-testid="support-page">
      <div className="af-container" style={{ maxWidth: 820 }}>
        <div className="af-eyebrow">Help</div>
        <h1 className="af-h2" style={{ marginTop: 14, marginBottom: 24 }}>Support</h1>

        <div className="af-lede" style={{ display: "grid", gap: 16, color: "#cfd3dc" }}>
          <p>Need help with an AithorityForge product?</p>
          <p>AithorityForge Solutions Ltd. provides support by email.</p>
          <p>
            For questions about PIN, Clip2SOP, SoulScript, account issues, app support, or general product questions,
            contact:
          </p>

          <div>
            <a
              href="mailto:stefan@aithorityforge.com"
              data-testid="support-email-link"
              className="af-btn af-btn-primary"
              style={{ fontSize: "1rem" }}
            >
              stefan@aithorityforge.com
            </a>
          </div>

          <p>We aim to review support requests as soon as possible.</p>

          <div
            style={{
              border: "1px solid var(--af-border-strong)",
              background: "var(--af-surface)",
              borderRadius: 12,
              padding: "1.1rem 1.2rem",
              color: "#cfd3dc",
              fontSize: "0.95rem",
              lineHeight: 1.6,
              marginTop: 8,
            }}
            data-testid="support-emergency-note"
          >
            For urgent safety, medical, mental health, legal, or emergency issues, contact the appropriate professional
            or emergency service. AithorityForge products are not a replacement for professional advice.
          </div>

          <p style={{ color: "var(--af-text-muted)", fontSize: "0.9rem", marginTop: 18 }}>
            AithorityForge Solutions Ltd. — Regina, Saskatchewan, Canada.
          </p>

          <div style={{ marginTop: 16 }}>
            <Link to="/" className="af-btn af-btn-ghost" data-testid="support-back-home">Back to home</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
